import { render } from "./language_selector.vue?vue&type=template&id=53691a95"
import script from "./language_selector.vue?vue&type=script&lang=js"
export * from "./language_selector.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/language_selector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53691a95"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53691a95', __exports__)) {
    api.reload('53691a95', __exports__)
  }
  
  module.hot.accept("./language_selector.vue?vue&type=template&id=53691a95", () => {
    api.rerender('53691a95', render)
  })

}


export default __exports__